// File Metadata:
// Filename: NewDeparture.js
// Version: 1.00
// Created: 2025-03-22 00:06:02
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React, { Component } from 'react'
import NewDepartureTU from './NewDepartureTU'
import NewDepartureFormHU from './NewDepartureFormHU'
import NewDepartureFormConfirm from './NewDepartureFormConfirm'
import NewDeparturePicture from './NewDeparturePicture'

export class NewDeparture extends Component {
    state = {
        step: 1,
        departureTour: '',
        scannedHUs: [],
        pendingHUs: [],
        destination: '',
        notes: [''],
        departureImages: []
    }

    nextStep = () => {
        const { step } = this.state
        this.setState({ step: step + 1 })
    }

    prevStep = () => {
        const { step } = this.state
        this.setState({ step: step - 1 })
    }

    handleChange = input => e => {
        this.setState({ [input]: e.target.value })
    }

    handleValue = (input, value) => {
        this.setState({ [input]: value })
    }

    render() {
        const { step } = this.state
        const { departureTour, scannedHUs, pendingHUs, destination, notes, departureImages } = this.state
        const values = { departureTour, scannedHUs, pendingHUs, destination, notes, departureImages }

        switch (step) {
            case 1:
                return <NewDepartureTU
                    nextStep={this.nextStep}
                    handleChange={this.handleChange}
                    handleValue={this.handleValue}
                    values={values}
                />
            case 2:
                return <NewDepartureFormHU
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleValue={this.handleValue}
                    values={values}
                />
            case 3:
                return <NewDeparturePicture
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleValue={this.handleValue}
                    values={values}
                />
            case 4:
                return <NewDepartureFormConfirm
                    prevStep={this.prevStep}
                    values={values}
                />
            default:
                return null
        }
    }
}

export default NewDeparture
